export interface NewsEntryBase {
  id: number;
  title: string;
  message: string;
  clickToAction?: string;
  link?: string;
}

export interface NewsEntry extends NewsEntryBase {
  created: Date;
}

export interface ServerNewsEntry extends NewsEntryBase {
  created: string;
}

export function mapNewsEntry(newsEntry: ServerNewsEntry): NewsEntry {
  return {
    ...newsEntry,
    created: new Date(newsEntry.created),
  };
}
